export default __webpack_public_path__ + "static/media/billpay_image.5e0022bc.png";